export const cardTemplateName = (cardTemplate: {name: string}) =>
  cardTemplate.name || 'Untitled card'

export const cardTemplateVersionName = (name?: string | null) =>
  (name ?? '') || 'Untitled card'
